import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/documents/columns";
import View from "../../assets/View";
import { getclientlist } from "../../api/request/service";
import UserAvatar from "../../components/common/UserAvatar";
import Search from "../../components/common/Search";
import GlobalTooltip from "../../components/common/GlobalTooltip";

const Documents = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const handleView = (data) => {
    navigate(`/document/${data?.id}`, {
      state: { client: data?.name },
    });
  };

  const getClientList = async (searchText) => {
    try {
      setIsLoading(true);
      const params = { page: currentPage, search: searchText };
      const { data } = await getclientlist(params);
      if (data?.status) {
        const clientData = data?.data?.map((item) => {
          return {
            ...item,
            userDetails: (
              <UserAvatar
                data={{
                  name: item?.name,
                  email: item?.email,
                  profile_image: item?.profile_image,
                }}
              />
            ),
            latest_doc: item?.latest_doc?.path ? (
              <div
                className="w-[250px] text-blue-500 overflow-hidden whitespace-nowrap text-ellipsis"
                onClick={(e) => e.stopPropagation()}
              >
                <a
                  href={item?.latest_doc?.path}
                  target="_blank"
                  title={item?.latest_doc?.original_name}
                >
                  {item?.latest_doc?.original_name}
                </a>
              </div>
            ) : null,
            created_at: item?.created_at
              ? moment(item?.created_at).format("LL")
              : "",
            action: (
              <div onClick={(e) => e.stopPropagation()}>
                <GlobalTooltip title={"View Document"}>
                  <button onClick={() => handleView(item)}>
                    <View />
                  </button>
                </GlobalTooltip>
              </div>
            ),
          };
        });
        setData(clientData);
        setTotal(data?.total_record);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getClientList();
  }, [currentPage]);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination?.current);
  };

  return (
    <div>
      <div className="border rounded-lg bg-White pb-5">
        <div className="flex items-center justify-between p-5">
          <p className="title">Documents</p>

          <div className="md:w-auto w-40">
            <Search handleSearch={getClientList} />
          </div>
        </div>

        <SkeletonTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
          onRowClick={(data) => handleView(data)}
        />
      </div>
    </div>
  );
};

export default Documents;
